import { Dialog, Text, Divider, Button, Flex } from "@fluentui/react-northstar";
import axios from "axios";
import { Component } from "react";
import IntlUtil from "../../../../core/helpers/intl-util";
import moment from "moment";

class UserConsent extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";

  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    this._isMounted = true;
    await this.loadPageData();
  }
  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  loadPageData = async () => {};
  renderConsentModal = () => {
    return (
      <>
        <Dialog
          backdrop={true}
          footer={
            <div className="">
              <Button
                className="m-r-10"
                onClick={async () => {
                  await this.props.handleConsentReject();
                }}
                secondary
                content={
                  this.props.type !== "withdraw"
                    ? IntlUtil.getText(this._intl_ns_common, "content.reject")
                    : IntlUtil.getText(this._intl_ns_common, "content.close")
                }
              />
              <Button
                primary={this.props.type !== "withdraw"}
                tinted={this.props.type === "withdraw"}
                onClick={async () => {
                  await this.props.handleConsentAccept();
                }}
                className={
                  this.props.type === "withdraw"
                    ? "vpa-consent-withdraw-button"
                    : ""
                }
                content={
                  this.props.type !== "withdraw"
                    ? IntlUtil.getText(this._intl_ns_common, "content.accept")
                    : IntlUtil.getText(this._intl_ns_common, "content.withdraw")
                }
              />
            </div>
          }
          // cancelButton={this.props.type!=="withdraw"?IntlUtil.getText(this._intl_ns_common,"content.reject"):IntlUtil.getText(this._intl_ns_common,"content.close")}
          // confirmButton={this.props.type!=="withdraw"?IntlUtil.getText(this._intl_ns_common,"content.accept"):IntlUtil.getText(this._intl_ns_common,"content.withdraw")}
          header={
            <div className="vpa-consent-dialog-header">
              <Text className="  text-semibold vpa-consent-dialog-header-text  text-fc-primary">
                <span className="text-fs-l">
                  {this.props.userConsentRecord?.consentTitle}
                </span>
              </Text>
              <div
                className={
                  this.props.isConsentSubmitted
                    ? "page-loader-alt"
                    : "page-title-separator"
                }
              ></div>
            </div>
          }
          open={this.props.isUserConsentModalOpen}
          content={
            <>
              {this.props.type === "withdraw" ? (
                <>
                  <div className="m-t-25 m-b-45">
                    <span>
                      {IntlUtil.getText(
                        this._intl_ns_common,
                        "notification.info.withdrawConsent"
                      )}{" "}
                      <span>
                        {moment(
                          this.props.userConsentRecord?.acceptTimestamp
                        ).format("MMM DD, YYYY")}
                      </span>{" "}
                      at{" "}
                      <span>
                        {moment(
                          this.props.userConsentRecord?.acceptTimestamp
                        ).format("HH:mm:ss")}
                        .
                      </span>
                    </span>
                  </div>
                </>
              ) : (
                <div className="vpa-consent-dialog-content">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.userConsentRecord?.consentInformation,
                    }}
                  />
                </div>
              )}
            </>
          }
          title="Consent"
          className="vpa-consent-page-dialog"
        />{" "}
      </>
    );
  };

  render() {
    return (
      <>
        <div id="spp-page-container">
          <div className="page-header-container"></div>
        </div>
        {this.renderConsentModal()}
      </>
    );
  }
}

export default UserConsent;
